import styled from '@emotion/styled';

type SizeProps = {
  width?: string;
  height?: string;
};

export const ContainerImage = styled.img<SizeProps>`
  display: flex;
  width: ${({ width }) => width ?? '72px'};
  height: ${({ height }) => height ?? '68px'};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  object-fit: contain;
`;
export const MixedContainerSVGWrapper = styled.div<SizeProps>`
  display: flex;
  width: ${({ width }) => width ?? '72px'};
  height: ${({ height }) => height ?? '68px'};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 6px;
`;

export const ContainerSVGWrapper = styled.div<SizeProps>`
  display: flex;
  width: ${({ width }) => width ?? '72px'};
  height: ${({ height }) => height ?? '68px'};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  ${({ width, height }) => !width && !height && `padding: 10px;`}
`;

export const ContainerImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 1;
`;

export const MixedCargoSmallIconWrapper = styled.div`
  position: relative;
  width: 0px;
  height: 0px;
  top: 0;
`;

export const MixedCargoSmallIconInnerWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0px;
`;
